import GameUtil from "../../../utility/game_util";
import { NotifyData, IRedPointData } from "../notify_data";

export enum RedPointModule{
    None=0,
    Mail=1,//邮件
    Activity = 2,//活动
    Task = 3,//任务
    Task_every=4,//每日任务
    Task_time = 5,//限时任务
    Task_growth=6,//成长任务
    VideoReward = 7, //视频广告
    Day_WelFare=8,//计时奖励
    Bag_Vip = 9,//背包vip奖励
}

//红点组件
const {ccclass, menu,property} = cc._decorator;

@ccclass
export class RedPointComponent extends cc.Component {

    @property({ type: cc.Enum(RedPointModule) })
    module: RedPointModule = RedPointModule.None

    @property(cc.Node)
    redPointNode:cc.Node = null;

    onLoad(){
        NotifyData.instance.registerRedPint(this);
        this.redPointNode.active = false;
    }

    onDestroy(){
        NotifyData.instance.removeRedPoint(this);
    }

    isExist(){
        return this.node && this.node.isValid;
    }

    isSameModule(comp:RedPointComponent){
        return comp.module == this.module;
    }

    //更新红点状态
    refreshRedPoint(data:IRedPointData){
        this.redPointNode.active =  data && data.isHave;
    }
}
